export type DashboardTab =
  | 'general'
  | 'students'
  | 'courses'
  | 'assignments'
  | 'lecturers'
  | 'certificates'
  | 'scorm';

export const DASHBOARD_TABS: { key: DashboardTab; label: string }[] = [
  { key: 'general', label: 'General Info' },
  { key: 'students', label: 'Student Analytics' },
  { key: 'courses', label: 'Course Statistics' },
  { key: 'assignments', label: 'Assignments & Tests' },
  { key: 'lecturers', label: 'Lecturer Statistics' },
  { key: 'certificates', label: 'Certificates & Achievements' },
  { key: 'scorm', label: 'SCORM Analytics' },
];

export const EXPORT_PAGE_OPTIONS = [
  { key: 'all', label: 'Export all pages' },
  { key: 'general', label: 'General Info' },
  { key: 'students', label: 'Student Analytics' },
  { key: 'courses', label: 'Course Statistics' },
  { key: 'assignments', label: 'Assignments & Tests' },
  { key: 'lecturers', label: 'Lecturer Statistics' },
  { key: 'certificatesAchievements', label: 'Certificates & Achievements' },
  { key: 'scorm', label: 'SCORM Analytics' },
] as const;
